var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import config from '@/config';
import axios from 'axios';
const getHeader = () => {
    return {
        channel: 'APP',
        source: 'WEB_USER',
        version: '2021-07-28',
        'source-id': 'platform-billing',
    };
};
export const requests = (host, useAuthorization = false) => {
    const baseUrl = host || config.INTERNAL_TOOLS_SERVICE_URL;
    const axiosInstance = axios.create({
        baseURL: baseUrl,
        headers: getHeader(),
    });
    axiosInstance.interceptors.request.use((requestConfig) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            requestConfig.headers['token-id'] = yield window.getToken();
            if (useAuthorization) {
                requestConfig.headers['authorization'] = `Bearer ${yield window.getAuthToken(true)}`;
            }
        }
        catch (e) {
            console.error(e);
        }
        return requestConfig;
    }));
    return axiosInstance;
};
